<template lang="pug">
v-card.sdo-card
  v-card-title.mb-0
    v-row.ma-0
      v-avatar.grey--text.text--lighten-2.mt-1.mr-4(
        color="secondary lighten-2" size="24"
      ): strong {{ idx + 1 }}
      span {{ unit.title }}
      v-spacer
      v-switch.pt-0.mt-1(
        :input-value="toggle"
        :label="`Использовать настройки ${entityName}`"
        hide-details
        @change="gptSettings.type = Number(!gptSettings.type); gptSettings.handleSave()"
      )
  v-card-text(
    v-if="gptSettings.type !== 0"
  )
    v-alert(
      type="info"
      icon="mdi-database"
      prominent
      text
      color="secondary"
    )
      v-list-item(light)
        v-list-item-content
          v-list-item-title База знаний:
          v-list-item-subtitle.normal-wrap.mb-4
            span {{ gptSettings.knowledgeBaseName }}
          v-btn-toggle.transparent(
            light
            v-model="gptSettings.type"
            color="white"
            mandatory
            @change="gptSettings.handleSave()"
          )
            v-btn.mt-1(
              v-for="btn in typeItems"
              :key="btn.value"
              :value="btn.value"
              small
              :color="gptSettings.type === btn.value ? btn.color : ''"
            ) {{ btn.text }}
        v-list-item-action
          v-btn(
            depressed color="secondary" outlined
            :icon="$vuetify.breakpoint.mdAndDown"
            @click="changeBaseKnowledge"
          )
            v-icon(:left="!$vuetify.breakpoint.mdAndDown") mdi-pencil
            span(v-if="!$vuetify.breakpoint.mdAndDown") Изменить

                //- v-icon(
                //-   :color="gptSettings.type === btn.value ? 'white' : ''"
                //- ).pr-2.pb-1 mdi-robot-dead
</template>
<script>
import GptSettings from '@/models/list/GptSettings';
import AutocompleateBaseKnowledge from './AutocompleateBaseKnowledge.vue';

export default {
  props: {
    entityName: { type: String, required: true },
    unit: { type: Object, required: true },
    idx: { type: Number, required: true },
  },
  data() {
    return {
      gptSettings: {},
      loading: true,
      typeItems: [
        // {
        //   value: 0,
        //   color: 'error',
        //   icon: 'mdi-robot-dead',
        //   text: 'Не используется',
        // },
        {
          value: 2,
          color: 'primary',
          icon: 'mdi-robot',
          text: 'Предлагает ответ',
        },
        {
          value: 1,
          color: 'success',
          icon: 'mdi-robot-happy',
          text: 'Отвечает самостоятельно ',
        },
      ],
    };
  },
  computed: {
    toggle() {
      return this.gptSettings?.type === 0;
    },
  },
  created() {
    this.getGptSettings();
  },
  methods: {
    async getGptSettings() {
      const params = {
        expand: 'course,course_unit,course_module',
        'search[course_unit_id]': this.unit.id,
      };
      const { data } = await this.$api.gptPulse.getUnitGptSettings(params);
      const settings = {
        ...data.data[0],
        course_unit: this.unit,
      };
      const parentEntity = { type: this.$route.meta.type, id: this.$route.params.id };
      this.gptSettings = new GptSettings(settings, 'course_unit', parentEntity);
      this.loading = false;
    },
    changeBaseKnowledge() {
      this.$modals.show('form-controller', {
        title: 'Редактирование базы знаний',
        method: ({ data }) => {
          const { baseKnowledge } = data;
          this.gptSettings.setBaseKnowledge(baseKnowledge);
          return new Promise((resolve) => { resolve({ data: {} }); });
        },
        fields: [{
          component: AutocompleateBaseKnowledge,
          text: 'Выберите базу знаний',
          value: 'baseKnowledge',
          rules: 'required',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        }],
      });
    },
  },
};
</script>
